import '../../i18n/autoTranslate';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import SpotlightCard from '../../../components/ui/SpotlightCard';

import { BsFillBarChartFill } from "react-icons/bs";
import { SiDialogflow } from "react-icons/si";
import { TbFileCv } from "react-icons/tb";
import { FaPlay } from "react-icons/fa";

const QuickStartSection = ({id="quick-start"}) => {
  const navigate = useNavigate();

  // NOTE: Use a key -> Tailwind class map so gradient classes are not purged.
  const gradientByKey = {
    purpleIndigo: 'from-purple-500/20 to-indigo-500/20',
    indigoPurple: 'from-indigo-500/20 to-purple-500/20',
    greenTeal: 'from-emerald-500/20 to-teal-500/20',
    amberOrange: 'from-amber-500/20 to-orange-500/20',
  };

  const quickActions = [
    {
      title: "Start Interview Practice",
      description: "Begin a personalized interview session",
      icon: <FaPlay size={32} className='text-indigo-400'/>,
      action: () => navigate('/interview-setup-configuration'),
      primary: true,
      gradientKey: "purpleIndigo",
      spotlight: "rgba(139, 92, 246, 0.2)"
    },
    {
      title: "Resume Analysis",
      description: "Get AI-powered feedback on your resume",
      icon: <TbFileCv size={32} className='text-indigo-400'/>,
      action: () => navigate('/resume-builder'),
      primary: false,
      gradientKey: "indigoPurple",
      spotlight: "rgba(99, 102, 241, 0.2)"
    },
    {
      title: "Questions AI",
      description: "Generate specific question for chosen role",
      icon: <SiDialogflow size={32} className='text-indigo-400'/>,
      action: () => navigate('/generate-questions'),
      primary: false,
      gradientKey: "greenTeal",
      spotlight: "rgba(16, 185, 129, 0.2)"
    },
    {
      title: "View Progress",
      description: "Track your improvement over time",
      icon: <BsFillBarChartFill size={32} className='text-indigo-400'/>,
      action: () => navigate('/progress-analytics-insights'),
      primary: false,
      gradientKey: "amberOrange",
      spotlight: "rgba(245, 158, 11, 0.2)"
    }
  ];

  return (
    <div id={id} className="space-y-6 overflow-hidden">
      <div className="text-center space-y-2">
        <h2 className="text-xl md:text-2xl font-bold text-white">Quick Start</h2>
        <p className="text-gray-300 text-sm md:text-base">
          Choose your next step to continue improving your interview skills
        </p>
      </div>
      {/* FIX: tablet gets 2 columns, desktop gets 4 */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {quickActions?.map((action, index) => (
          <SpotlightCard
            key={index}
            className={
              `group relative rounded-2xl overflow-hidden backdrop-blur-xl shadow-[0_14px_50px_rgba(0,0,0,0.35)] p-5 custom-spotlight-card h-full ` +
              // FIX: primary card has stronger visual weight
              (action.primary ? 'border border-white/20 bg-white/10' : 'border border-white/10 bg-white/5')
            }
            spotlightColor={action.spotlight}
          >
              {/*
                FIX: gradient per-card is applied to the card background (soft). 
                Uses class map to avoid Tailwind purge.
              */}
              <div className={`absolute inset-0 bg-gradient-to-br ${gradientByKey[action.gradientKey]} opacity-70`} />

              <div className="relative z-10 h-full flex flex-col gap-4">
                <div className="flex items-center gap-4">
                  {action?.icon}
                  {/* Content */}
                  <div className="space-y-2">
                    <h3 className="text-lg font-semibold text-white">{action?.title}</h3>
                    <p className="text-sm text-gray-300">{action?.description}</p>
                  </div>
                </div>

                {/* Action Button */}
                <Button
                  // FIX: secondary cards use outline buttons
                  variant={action.primary ? 'default' : 'outline'}
                  fullWidth
                  onClick={action?.action}
                  iconName="ArrowRight"
                  iconPosition="right"
                  className="mt-auto"
                >
                  {action?.primary ? "Start Now" : "Explore"}
                </Button>
              </div>
          </SpotlightCard>
        ))}
      </div>
    </div>
  );
};

export default QuickStartSection;
